<template>
  <div class="overflow-scroll-y">

    <!-- <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108.png" usemap="#ImageMap" alt="" />
        <map name="ImageMap">
          <area shape="poly" coords="590,1371,589,1370,690,1364,692,1394,592,1398,592,1398" href="#" alt="" />
          <area shape="poly" coords="707,1364,1019,1353,1019,1383,707,1392,707,1392" href="#" alt="" />
          <area shape="poly" coords="480,1408,581,1403,582,1431,482,1434,482,1434" href="#" alt="" />
          <area shape="poly" coords="596,1403,794,1397,794,1424,598,1431,650,1439" href="#" alt="" />
          <area shape="poly" coords="284,1474,863,1452,862,1596,287,1615,286,1537" href="javascript:alert(2)" alt="" />
          <area shape="circle" coords="1080,70,39" href="#" onclick="alert(1)" alt="" />
        </map> -->
    <div class="card-header">
      <h2 v-if="formatId != 'rirekisho_esf_challenged'">目的に合わせて選ぶ</h2>
      <h2 v-else>完了</h2>
      <p v-if="false">作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
      <p style="color:red;" v-if="!$firebase.isAuthenticated">
        ※ヤギの宅配便、メール送信、コンビニ印刷、ダウンロードはログインが必須となります。<br>下記のログインフォームでログインしてください。</p>
    </div>

    <div class="card-content" v-if="formatId != 'rirekisho_esf_challenged'">
      <div class="button-download-pdf" v-if="$firebase.isAuthenticated">
        <div class="bnr_container" v-if="formatId == 'internship'" style="padding: 0;">
          <div class="bnr_item">
            <img v-if="!isSendedYagishIntern" @click="$eventHub.$emit('send-yagish-intern'); isSendedYagishIntern = true;"
              src="/static/renew_img/bnr/intern_yagish_bnr_20230414.png" alt="Yagishインターン">
            <div class="bnr_txt" v-if="!isSendedYagishIntern">
              <ul style="font-size: 0.8rem; margin-left: 0;text-align: left;">
                <li>※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。</li>
                <li>※選考に進む際はこちらからご連絡いたします。</li>
                <li>※インターンに関する採用情報は<a href="https://www.yagish.jp/recruit-info/intern2023/"
                    target="_blank">こちら</a>からご確認ください。</li>
              </ul>
            </div>
            <div class="bnr_txt" v-else>
              <ul style="font-size: 0.8rem; margin-left: 0;">
                <li>履歴書が送付されました。ありがとございます</li>
              </ul>
            </div>
          </div>
        </div>

        <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">

          <div id="quickemail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>応募先企業に1クリックで送信</p>
                  <br>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/quickemail_img20231122.png" alt="ヤギのメール便"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                  @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                  <p>登録したメアドに送るメェ〜</p>
                  <br>
                  <h3>PDFをメールで送る</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_mail_20230929.png" alt="PDFメール" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                  <p>PDFファイルを</p>
                  <p>登録したメアドに送るためには</p>
                  <br>
                  <h3>確認メールで送る</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>


          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="$eventHub.$emit('show-preview-4conv')">
                  <p>面接に履歴書が必要？印刷だメェ〜ェ〜</p>
                  <br>
                  <h3>コンビニプリント<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/print.png" alt="コンビニプリント" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                  @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                  <p>履歴書送付は任せろメェ〜</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_download_20230929.png" alt="PDFダウンロード"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

        </div>

        <div id="completed-buttons" class="bnr_container" v-else>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">

                  <span>
                    <p>登録したメアドに送るメェ〜</p><br>
                    <h3>自分にメール</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                  <p>PDFファイルを</p>
                  <p>登録したメアドに送るためには</p>
                  <br>
                  <h3>確認メールで送る</h3>
                </el-button>
              </div>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>


          <div id="quickemail" class="bnr_itemWrapper" v-if="$globalVar.in_app_payments">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_new_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="quick-email-btn"
                @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>{{ qemailBtnLabel }}</p>
                  <br>
                  <h3>応募先にメール<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>
          <div id="quickemail" class="bnr_itemWrapper" v-else-if="false">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="quick-email-btn"
                @click="$eventHub.$emit('send-special-newquickemail', formatId); isSendYagiEmailEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-newquickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>{{ qemailBtnLabel }}</p>
                  <br>
                  <h3>応募先にメール<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew2_img/print_20231024.png" alt="コンビニプリント" id="pdf-eprint-btn"
                @click="$eventHub.$emit('show-preview-4conv')">
              <div class="bnr_txt">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="$eventHub.$emit('show-preview-4conv')">
                  <p>面接に履歴書が必要？印刷だメェ〜ェ〜</p>
                  <br>
                  <h3>コンビニ印刷<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper" v-if="!isMaint && $globalVar.in_app_payments">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickmail_btn_20231120.png" alt="ヤギの宅配便"
                :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" id="quick-mail-btn"
                @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                  @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                  <p>{{ qmailBtnLabel }}</p>
                  <br>
                  <h3>応募先に郵送<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便"
                :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" id="quick-mail-btn" @click="alertMaint">
              <div class="bnr_txt">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" @click="alertMaint">
                  <p>履歴書送付は任せろメェ〜</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/download_bnr_20231011.png" id="pdf-download-btn"
                :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
              <div class="bnr_txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <span class="">
                    <p>端末に保存するメェ〜</p><br>
                    <h3>端末に保存</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

        </div>

      </div>
      <div class="button-download-pdf" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
    <div id="dl_useraim" v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 0">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを使う</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240425.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      メールに送る
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('send-email-verification'); mailPdfEnabled = false">
                      認証メールで送る
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-if="formatId != 'rirekisho_design_001' && $globalVar.in_app_payments">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                      企業にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right" v-if="formatId != 'rirekisho_design_001'">
                <h3 class="h3">紙に印刷</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240425.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="$eventHub.$emit('show-preview-4conv')">
                      コンビニ印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      企業に郵送代行
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
    <div id="dl_useraim" v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 1">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240509p1.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      自分にメール
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('send-email-verification'); mailPdfEnabled = false">
                      認証メールで送る
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments && formatId != 'rirekisho_design_001'">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right" v-if="formatId != 'rirekisho_design_001'">
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240509p1.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="$eventHub.$emit('show-preview-4conv')">
                      コンビニ印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      {{ qmailBtnLabel }}
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
    <div id="dl_useraim" v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 2">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons" class="pdf-download-box-wrap"><!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_mail_20240509p2.png" alt="PDFを使う" class="btn-img">
                  <div class="btn-item" v-if="$firebase.user.emailVerified">
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      自分にメール
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-else>
                    <el-button id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('send-email-verification'); mailPdfEnabled = false">
                      認証メールで送る
                    </el-button>
                    <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>メールが受信できない場合</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments && formatId != 'rirekisho_design_001'">
                    <el-button id="quick-email-btn" :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギのメール便について</a>
                  </div>
                </div>
              </div>
              <div class="right" v-if="formatId != 'rirekisho_design_001'">
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img src="/static/renew2_img/download_page_paper_20240509p2.png" alt="紙に印刷" class="btn-img">
                  <div class="btn-item">
                    <el-button id="pdf-eprint-btn" @click="$eventHub.$emit('show-preview-4conv')">
                      コンビニ印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button id="quick-mail-btn" :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      郵送を依頼
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"><span
                        class="notelink-icon">?</span>ヤギの宅配便について</a>
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="$site.appFlag != 'b'">
                <div class="btn-item">
                  <el-button id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                    @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                    端末に保存
                  </el-button>
                  <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                    class="notelink"><span class="notelink-icon">?</span>端末に保存できない場合</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
    <div id="dl_disability" v-else-if="formatId == 'rirekisho_esf_challenged'">
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf">
          <div id="completed-buttons">

            <!--ボタン-->
            <div id="intro_shogai" class="flex bnr_itemWrapper"
              @click="$eventHub.$emit('send-recommend-request-shogai');">
              <div class="bnr_item">
                <img src="/static/renew2_img/icon_recommend_dl_disability.svg" alt="推薦・紹介文作成を依頼する" class="intro_icon">
              </div>
              <div class="bnr_txt">
                <p>就労支援施設に推薦・紹介文作成をしてもらうと、<br class="pc">自分の履歴書に推薦・紹介文が添付されます</p>
                <button type="button" class="el-button--default request-btn" id="shogai-recommend-btn">依頼する</button>
              </div>
            </div>
            <p class="note">※依頼すると、「推薦・紹介」ページで入力したメールアドレスに依頼メールが送信されます</p>

            <div class="edit-wrapper">
              <div class="flex bnr_txt">
                <p>推薦・紹介文なしで<br class="sp">オファーを受ける</p>
                <button type="button" class="el-button--default edit-btn"
                  @click="$eventHub.$emit('regist-yagioffer-shogai')" id="shogai-recommend-btn">オファーを受ける</button>
              </div>
            </div>
            <div class="edit-wrapper">
              <div class="flex bnr_txt">
                <p>履歴書の内容を<br class="sp">書き換える・書き直す場合</p>
                <button type="button" class="el-button--default edit-btn"
                  @click="$eventHub.$emit('go-card-to', 'profile')" id="shogai-recommend-btn">修正する</button>
              </div>
            </div>

            <!--そのほかのアクション-->
            <div class="other-action-block">
              <p class="action-title">作成した履歴書は保存したり、実際に企業に提出することもできます</p>
              <div class="flex">
                <div class="action-list">
                  <p class="action-title">保存する</p>
                  <div class="bnr_txt">
                    <button type="button" class="el-button el-button--default" id="pdf-mail-btn"
                      @click="$eventHub.$emit('mail-PDF');"><!----><!---->
                      登録メアドにPDFをメールで送る
                    </button>
                    <p class="bnr_note">
                      <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank" rel="nofollow">
                        ※メールが受信できない場合はこちら
                      </a>
                    </p>
                  </div>
                  <div class="bnr_txt">
                    <button type="button" class="el-button el-button--default" id="pdf-download-btn"
                      @click="$eventHub.$emit('download-PDF');"><!----><!---->
                      端末にダウンロードする
                    </button>
                    <p class="bnr_note">
                      <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                        target="_blank" rel="nofollow">
                        ※ダウンロードできない場合はこちら
                      </a>
                    </p>
                  </div>
                </div>
                <div class="action-list">
                  <p class="action-title">印刷する</p>
                  <div class="bnr_txt">
                    <button type="button" class="el-button el-button--default" id="pdf-eprint-btn"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      コンビニ印刷する
                    </button>
                  </div>
                </div>
                <div class="action-list">
                  <p class="action-title">提出する</p>
                  <div class="bnr_txt">
                    <button type="button" class="el-button el-button--default" id="quick-email-btn"
                      @click="$eventHub.$emit('send-special-quickemail', formatId);">
                      企業にメールでPDFを提出する
                    </button>
                  </div>
                  <div class="bnr_txt">
                    <button type="button" class="el-button el-button--default" id="quick-mail-btn"
                      @click="$eventHub.$emit('send-special-post', formatId);">
                      印刷郵送を代行で企業に提出する
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <shogailogin-forms />
        </div>
      </div>
    </div>
    <div class="card-content" v-else-if="false">
      <div class="button-download-pdf" v-if="$firebase.isAuthenticated">
        <div class="bnr_container" v-if="formatId == 'internship'" style="padding: 0;">
          <div class="bnr_item">
            <img v-if="!isSendedYagishIntern" @click="$eventHub.$emit('send-yagish-intern'); isSendedYagishIntern = true;"
              src="/static/renew_img/bnr/intern_yagish_bnr_20230414.png" alt="Yagishインターン">
            <div class="bnr_txt" v-if="!isSendedYagishIntern">
              <ul style="font-size: 0.8rem; margin-left: 0;text-align: left;">
                <li>※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。</li>
                <li>※選考に進む際はこちらからご連絡いたします。</li>
                <li>※インターンに関する採用情報は<a href="https://www.yagish.jp/recruit-info/intern2023/"
                    target="_blank">こちら</a>からご確認ください。</li>
              </ul>
            </div>
            <div class="bnr_txt" v-else>
              <ul style="font-size: 0.8rem; margin-left: 0;">
                <li>履歴書が送付されました。ありがとございます</li>
              </ul>
            </div>
          </div>
        </div>

        <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">

          <div id="quickemail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>応募先企業に1クリックで送信</p>
                  <br>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/quickemail_img20231122.png" alt="ヤギのメール便"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                  @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                  <p>登録したメアドに送るメェ〜</p>
                  <br>
                  <h3>PDFをメールで送る</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_mail_20230929.png" alt="PDFメール" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                  <p>PDFファイルを</p>
                  <p>登録したメアドに送るためには</p>
                  <br>
                  <h3>確認メールで送る</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>


          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="$eventHub.$emit('show-preview-4conv')">
                  <p>面接に履歴書が必要？印刷だメェ〜ェ〜</p>
                  <br>
                  <h3>コンビニプリント<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/print.png" alt="コンビニプリント" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                  @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                  <p>履歴書送付は任せろメェ〜</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便" style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>端末に保存するメェ〜</p>
                  <br>
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <img src="/static/renew2_img/pdf_download_20230929.png" alt="PDFダウンロード"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

        </div>

        <div id="completed-buttons" class="bnr_container" v-else>
          <div id="intro_shogai" class="bnr_itemWrapper" v-if="formatId == 'rirekisho_esf_challenged'">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_new_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="shogai-recommend-btn"
                @click="$eventHub.$emit('send-recommend-request-shogai');">
              <div class="bnr_txt">
                <el-button id="shogai-recommend-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-recommend-request-shogai');">
                  <p>紹介・推薦状作成を依頼する</p>
                  <br>
                  <h3>ヤギの推薦依頼<span>をおくる</span></h3>
                </el-button>
              </div>
            </div>
          </div>


          <div id="quickemail" class="bnr_itemWrapper"
            v-if="formatId != 'rirekisho_job_new1' && formatId != 'rirekisho_job_new_single1'">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_new_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="quick-email-btn"
                @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>{{ qemailBtnLabel }}</p>
                  <br>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>
          <div id="quickemail" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <img src="/static/renew2_img/quickemail_btn_20240221.png" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="quick-email-btn"
                @click="$eventHub.$emit('send-special-newquickemail', formatId); isSendYagiEmailEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-email-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-newquickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>{{ qemailBtnLabel }}</p>
                  <br>
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
              <div class="bnr_txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                  @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">

                  <span>
                    <p>登録したメアドに送るメェ〜</p><br>
                    <h3>PDFをメールで送る</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                  rel="nofollow">※メールが受信できない場合はこちら</a>
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                  <p>PDFファイルを</p>
                  <p>登録したメアドに送るためには</p>
                  <br>
                  <h3>確認メールで送る</h3>
                </el-button>
              </div>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※ログインが必要です。</p>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew2_img/print_20231024.png" alt="コンビニプリント" id="pdf-eprint-btn"
                @click="$eventHub.$emit('show-preview-4conv')">
              <div class="bnr_txt">
                <el-button id="pdf-eprint-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  @click="$eventHub.$emit('show-preview-4conv')">
                  <p>面接に履歴書が必要？印刷だメェ〜ェ〜</p>
                  <br>
                  <h3>コンビニプリント<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper" v-if="!isMaint">
            <div class="bnr_item">
              <img src="/static/renew2_img/quickmail_btn_20231120.png" alt="ヤギの宅配便"
                :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" id="quick-mail-btn"
                @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
              <div class="bnr_txt">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                  @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                  <p>{{ qmailBtnLabel }}</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便"
                :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" id="quick-mail-btn" @click="alertMaint">
              <div class="bnr_txt">
                <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" @click="alertMaint">
                  <p>履歴書送付は任せろメェ〜</p>
                  <br>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item free-icon">
              <img src="/static/renew2_img/download_bnr_20231011.png" id="pdf-download-btn"
                :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
              <div class="bnr_txt">
                <el-button id="pdf-download-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <span class="">
                    <p>端末に保存するメェ〜</p><br>
                    <h3>PDFをダウンロードする</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※できない場合はこちら</a>
              </p>
            </div>
          </div>

        </div>

      </div>
      <div class="button-download-pdf" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
    <div id="dl_2column" v-else>
      <div class="card-content">
        <div class="button-download-pdf"><!---->
          <div id="completed-buttons"><!---->

            <div id="intro_shogai" class="bnr_itemWrapper" v-if="formatId == 'rirekisho_esf_challenged'">
              <div class="bnr_item">
                <img src="/static/renew2_img/quickemail_new_btn_20240221.png" alt="ヤギのメール便"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled" id="shogai-recommend-btn"
                  @click="$eventHub.$emit('send-recommend-request-shogai');">
                <div class="bnr_txt">
                  <el-button id="shogai-recommend-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                    :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                    @click="$eventHub.$emit('send-recommend-request-shogai');">
                    <p>紹介・推薦状作成を依頼する</p>
                    <br>
                    <h3>ヤギの推薦依頼<span>をおくる</span></h3>
                  </el-button>
                </div>
              </div>
            </div>
            <div class="pdf-download-box">
              <h3 class="h3">＼今すぐPDFを保存したい／</h3>
              <div class="bnr_container">
                <div id="pdf-email" class="bnr_itemWrapper">
                  <div class="bnr_item free-icon" v-if="$firebase.user.emailVerified"><img
                      src="/static/renew2_img/mail_bnr_20231011.png" id="pdf-mail-btn"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                    <div class="bnr_txt">
                      <el-button id="pdf-mail-btn"
                        style="width: 100%; border: 0px; padding: 0px; background: rgb(239, 248, 248);"
                        :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                        @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                        <span>
                          <p>登録メアドにPDF送付</p><br>
                          <h3>メールに送る</h3>
                        </span>
                      </el-button>
                    </div>
                    <p class="bnr_note"><a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                        rel="nofollow">※メールが受信できない場合はこちら</a></p><!---->
                  </div>
                  <div class="bnr_item free-icon" v-else><img src="/static/renew2_img/mail_bnr_20231011.png"
                      id="pdf-mail-btn" :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                    <div class="bnr_txt">
                      <el-button id="pdf-mail-btn"
                        style="width: 100%; border: 0px; padding: 0px; background: rgb(239, 248, 248);"
                        :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                        @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                        <span>
                          <p>PDFファイルを</p><br>
                          <p>登録したメアドに送るためには</p><br>
                          <h3>確認メールで送る</h3>
                        </span>
                      </el-button>
                    </div>
                    <p class="bnr_note"><a href="https://www.yagish.jp/information/pdf_mail_setting/" target="_blank"
                        rel="nofollow">※メールが受信できない場合はこちら</a></p><!---->
                  </div>
                </div>
                <div id="pdf-download" class="bnr_itemWrapper">
                  <div class="bnr_item free-icon"><img src="/static/renew2_img/download_bnr_20231011.png"
                      id="pdf-download-btn" :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                    <div class="bnr_txt">
                      <el-button id="pdf-download-btn"
                        style="width: 100%; border: 0px; padding: 0px; background: rgb(239, 248, 248);"
                        :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                        @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                        <span class="">
                          <p>端末に保存する</p><br>
                          <h3>ダウンロード</h3>
                        </span>
                      </el-button>
                    </div>
                    <p class="bnr_note"><a
                        href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                        target="_blank" rel="nofollow">※できない場合はこちら</a></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="pdf-eprint-box">
              <h3 class="h3">＼自分で紙に印刷したい／</h3>
              <div class="bnr_container">
                <div id="combie" class="bnr_itemWrapper">
                  <div class="bnr_item"><img src="/static/renew2_img/print_20231024.png" alt="コンビニプリント"
                      id="pdf-eprint-btn" @click="$eventHub.$emit('show-preview-4conv')">
                    <div class="bnr_txt">
                      <el-button id="pdf-eprint-btn"
                        style="width: 100%; border: 0px; padding: 0px; background: rgb(239, 248, 248);"
                        @click="$eventHub.$emit('show-preview-4conv')">
                        <p>コピー機がなくても</p><br>
                        <h3>コンビニ<span>で印刷</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pdf-yagish-service">
              <h3 class="h3">＼そのまま企業に提出したい／</h3>
              <div class="bnr_container">
                <div id="quickemail" class="bnr_itemWrapper">
                  <div class="bnr_item"><img src="/static/renew2_img/quickemail_new_btn_20240221.png" alt="ヤギのメール便"
                      id="quick-email-btn" :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                    <div class="bnr_txt">
                      <el-button id="quick-email-btn"
                        style="width: 100%; border: 0px; padding: 0px; background: rgb(239, 248, 248);"
                        :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                        @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                        <p>１クリックで送信</p><br>
                        <h3>ヤギのメール便</h3>
                      </el-button>
                    </div>
                  </div>
                </div>
                <div id="quickmail" class="bnr_itemWrapper">
                  <div class="bnr_item"><img src="/static/renew2_img/quickmail_btn_20231120.png" alt="ヤギの宅配便"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" id="quick-mail-btn"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                    <div class="bnr_txt">
                      <el-button id="quick-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                        <p>履歴書送付代行</p><br>
                        <h3>ヤギの宅配便</h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content" v-if="false">
      <el-collapse v-model="downloadActiveCollapses">

        <el-collapse-item title="ヤギにはがきを渡す" v-if="false" name="postcard">
          <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
        </el-collapse-item>

        <el-collapse-item title="スマホから履歴書を印刷するには" name="print">
          <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。</div>
          <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
          <ul class="collapse-list" v-if="$firebase.isAuthenticated">
            <li>
              <a id="pdf-eprint-edit" type="success" style="cursor:pointer;" :disabled="!$deviceLib.isOnline"
                @click="$eventHub.$emit('show-preview-4conv')">
                セブンイレブン・ファミリーマート・ローソンなど - eプリント
              </a>
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="他の端末から続きを書くには" name="backup">
          <div>
            他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}






* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  //padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}

.free-icon {
  position: relative;
}

.free-icon::before {
  position: absolute;
  content: "";
  // background-image: url(/static/renew2_img/free_icon.png);
  width: 62px;
  height: 39px;
  background-size: contain;
  display: inline-block;
  top: 5px;
  left: 5px;
}
</style>
<style lang="scss" scoped>
#dl_2column .h3 {
  text-align: center;
  margin-bottom: 10px;
}

#dl_2column .pdf-download-box,
#dl_2column .pdf-eprint-box {
  margin-bottom: 30px;
}

#dl_2column .pdf-eprint-box .bnr_container {
  justify-content: center;
}

@media screen and (max-width: 599px) {

  #dl_2column .card-content {
    padding-left: 0;
    padding-right: 0;
    border-top: 1px solid #f8f8f8;
  }

  #dl_2column .bnr_itemWrapper {
    width: calc(100% / 2 - 5px);
    margin: 0;
  }

  #dl_2column .bnr_container {
    justify-content: space-between;
    margin: 0;
  }

  #dl_2column .bnr_note {
    font-size: 0.6rem;
    margin-top: 8px;
  }

  #dl_2column .bnr_item img {
    border-radius: 5px 5px 0 0;
  }

  #dl_2column .bnr_txt {
    border-radius: 0 0 5px 5px;
  }
}
</style>
<style lang="scss" scoped>
#dl_disability .card-content {
  padding-top: 0;
}

#dl_disability .bnr_itemWrapper {
  width: 100%;
  margin: 0;
  background: #FFF0F0;
  border-radius: 10px;
  border: 3px solid #E3165C;
  justify-content: center;
  align-items: center;
}

#dl_disability .bnr_txt {
  border-radius: 0;
  background: none;
  padding: 0 15px 10px;
}

#dl_disability .bnr_txt p {
  font-size: 14px;
  font-weight: normal;
  font-family: auto;
}

#dl_disability .bnr_txt p a {
  font-size: 12px;
}

#dl_disability .intro_icon {
  padding: 20px;
  width: 150px;
}

#dl_disability .request-btn {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 10px 50px;
  margin-top: 10px;
  background: #E3165C;
  border-radius: 50px;
}

#dl_disability .note {
  font-size: 12px;
}

#dl_disability .edit-wrapper {
  margin-top: 30px;
  background: #eee;
  border-radius: 10px;
  padding: 20px;
}

#dl_disability .edit-wrapper .bnr_txt {
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
}

#dl_disability .edit-wrapper .bnr_txt .edit-btn {
  padding: 5px 20px;
  background: #404040;
  color: #fff;
  border-radius: 50px;
  margin-left: 30px;
}

#dl_disability .other-action-block {
  margin-top: 50px;
}

#dl_disability .action-title {
  font-weight: bold;
  font-size: 15px;
  color: #004D40;
  margin-bottom: 10px;
  text-align: center;
}

#dl_disability .action-list {
  width: calc(100% / 3 - 10px);
  background: #eff8f8;
  border-radius: 10px;
  padding: 20px 10px 10px;
}

#dl_disability .other-action-block .flex {
  justify-content: space-between;
}

#dl_disability .el-button {
  border: none;
  padding: 0;
  background: no-repeat;
  color: #404040;
  font-weight: bold;
}

@media screen and (max-width: 640px) {
  #dl_disability .flex {
    display: block;
  }

  #dl_disability .action-list {
    width: 100%;
    margin-bottom: 15px;
  }

  #dl_disability .bnr_txt {
    text-align: center;
    padding-bottom: 20px;
  }

  #dl_disability .edit-wrapper .bnr_txt .edit-btn {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
#dl_useraim .pdf-download-box-wrap {
  background: #EEF5E8;
  margin: 0 calc(50% - 50vw);
  width: 100vw;
}

#dl_useraim .card-content {
  padding: 0;
}

#dl_useraim .pdf-download-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1.5rem;
  max-width: 630px;
  margin: 0 auto;
}

#dl_useraim .left,
#dl_useraim .right {
  width: 49%;
  background: #fff;
  border-radius: 10px;
}

#dl_useraim .h3 {
  text-align: center;
  color: #fff;
  letter-spacing: 0.1rem;
  background: #004D40;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  font-size: 1rem;
}

#dl_useraim .btn-img {
  display: block;
  height: 80px;
  width: auto;
  margin: 0 auto;
}

#dl_useraim .btn-list {
  padding: 10px;
}

#dl_useraim .btn-item {
  margin: 10px auto 15px;
}

#dl_useraim .btn-item:last-child {
  margin-bottom: 0;
}

#dl_useraim .btn-item button {
  position: relative;
  width: 100%;
  border: none;
  background: #E3165C;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 4px 0 #8C103A;
}

#dl_useraim .btn-item button::after {
  position: absolute;
  content: "";
  right: 10px;
  top: 50%;
  margin-top: -4px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

#dl_useraim .notelink {
  display: block;
  font-size: 0.6rem;
  margin-top: 5px;
}

#dl_useraim .notelink-icon {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #404040;
  color: #fff;
  text-align: center;
  line-height: 15px;
  margin-right: 5px;
}

#dl_useraim .bottom {
  padding: 10px 10px 0;
  width: 49%;
}

#dl_useraim .bottom button {
  background: #fff;
  color: #404040;
  box-shadow: 0 4px 0 #004D40;
}

#dl_useraim .bottom .btn-item button::after {
  border-top: 2px solid #004D40;
  border-right: 2px solid #004D40;
}

#dl_useraim .btn-item button:hover {
  opacity: 1;
  transform: translateY(4px);
  box-shadow: none;
}
</style>
<script>
import LoginForms from '@/components/LoginSpecialForms'
import ShogaiLoginForms from '@/components/ShogaiLoginSpecialForms'
export default {
  props: {
    formatId: {
      type: String
    },
    isSendYagiPostEnabled: {
      type: Boolean
    },
    isSendYagiEmailEnabled: {
      type: Boolean
    },
    mailPdfEnabled: {
      type: Boolean
    },
    downloadPdfEnabled: {
      type: Boolean
    },
    downloadActiveCollapses: {
      type: Array
    }
  },
  components: {
    'login-forms': LoginForms,
    'shogailogin-forms': ShogaiLoginForms
  },
  data: function () {
    const app = this
    return {
      isWeekEndFlag: true,
      errors: [],
      abtest: 0,
      isMaint: false,
      isSendedYagishIntern: false,
      qemailBtnLabel: 'ポチッと企業に送信だメェ〜',
      qmailBtnLabel: '郵送を依頼',
      qemailBtnLabels20231113: [
        'ポチッと企業に送信だメェ〜',
        '提出までやっちゃうメェ〜',
        '1クリックで送信だメェ〜',
        'メールで提出は任せろメェ〜',
        'メールで送信まで任せてメェ〜'
      ],
      qemailBtnLabels: [
        'メールで企業に送信するなら⁉︎',
        'メールで効率的に企業に送信！',
        '履歴書を送って！と言われたら',
        '安全・安心に企業へ応募するなら',
        '1クリックで送信だメェ〜'
      ]
    }

  },
  created: function () {

    const nowdate = new Date()
    const date1 = new Date('2023/09/29 00:00:00')
    const date2 = new Date('2023/10/06 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    const date21 = new Date('2023/11/01 12:00:00')
    const date22 = new Date('2023/11/07 18:00:00')
    if (nowdate > date21 && nowdate < date22) {
      this.isMaint = true
    } else {
      this.isMaint = false
    }

    const nowdate2 = new Date()
    const date12 = new Date('2024/05/05 00:00:00')
    const enddate = new Date('2024/05/30 00:00:00')
    const enddate2 = new Date('2124/05/17 00:00:00')
    /*日時の差をミリ秒単位で取得*/
    let diffMilliSec = nowdate2 - date12
    /*ミリ秒を日数に変換*/
    let diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24)

    // console.error(date12 >= nowdate2)
    // console.error(date12 >= nowdate2)
    // if (date12 <= nowdate2 && enddate >= nowdate2 || nowdate2 > enddate2) {
    if (diffDays % 2 == 0) {
      this.abtest = 1
    } else {
      this.abtest = 2
    }

    const qmdate1 = new Date('2024/05/30 00:00:00')
    const qmdate2 = new Date('2024/06/06 00:00:00')
    const qmdate3 = new Date('2024/06/13 00:00:00')
    const qmdate4 = new Date('2024/06/20 00:00:00')
    if (nowdate >= qmdate1 && nowdate <= qmdate2) {
      this.qmailBtnLabel = "郵送を依頼"
    } else if (nowdate >= qmdate2 && nowdate <= qmdate3) {
      this.qmailBtnLabel = "配達依頼"
    } else if (nowdate >= qmdate3 && nowdate <= qmdate4) {
      this.qmailBtnLabel = "郵送を依頼"
    } else if (nowdate >= qmdate4) {
      this.qmailBtnLabel = "配達依頼"
    }
    this.qmailBtnLabel = "面倒な履歴書発送をYagishにお任せ！"

    // } 

    // this.abtest = 0

    if (diffMilliSec < 0) {
      console.error(this.qemailBtnLabels[diffDays])

    } else if (diffDays > 4) {
      let _idx = diffDays % 5
      // console.error(_idx)
      // console.error(this.qemailBtnLabels[_idx])
      this.qemailBtnLabel = this.qemailBtnLabels[_idx]

    } else {
      // console.error(this.qemailBtnLabels[diffDays])
      this.qemailBtnLabel = this.qemailBtnLabels[diffDays]
    }
    let dayOfWeek = nowdate.getDay()
    let dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]

    // if (dayOfWeek == 0) {
    //   this.qemailBtnLabel='安全・安心に企業へ応募するなら'
    // } else if (dayOfWeek == 6) {
    //   this.qemailBtnLabel='入力は最低限！あとはポチるだけ！'
    // } else if (dayOfWeek == 4 || dayOfWeek == 5) {
    //   this.qemailBtnLabel='企業に1クリックで送信だメェ〜'
    // } else {
    //   this.qemailBtnLabel='1クリックで送信だメェ〜'
    // }
    // if (dayOfWeek == 0) {
    //   this.qemailBtnLabel='企業に1クリックで送信だメェ〜'
    // } else if (dayOfWeek == 6) {
    //   this.qemailBtnLabel='企業に1クリックで送信だメェ〜'
    // } else if (dayOfWeek == 4 || dayOfWeek == 5) {
    //   this.qemailBtnLabel='1クリックで送信だメェ〜'
    // } else {
    //   this.qemailBtnLabel='1クリックで送信だメェ〜'
    // }

    // if (dayOfWeek == 1) {
    //   this.qmailBtnLabel='入力だけで企業に郵送完了'
    // } else if (dayOfWeek == 2) {
    //   this.qmailBtnLabel='ヤギが配達するメェ〜'
    // } else if (dayOfWeek == 3) {
    //   this.qmailBtnLabel='ヤギが企業に届けるよ！任せてメェ〜'
    // } else {
    //   this.qmailBtnLabel='履歴書送付は任せろメェ〜'
    // }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    alertMaint: function () {
      this.$message({
        message: '以下の日時においてヤギの宅配便サービスの休止を行います。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
        type: 'error'
      })

    }
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  destroyed: function () {
  }
}
</script>
